import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'GetInitials',
    standalone: false
})
export class GetInitialsPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    if (!value) {
      return '';
    }
    return value.replace(/[^A-Z]/g, '').substring(0, 3);
  }
}
